package com.nonopn.skywatcher.app.utils

object PackageInformation {
    var name: String = ""
}